import type { FC } from 'react';

import { chakra } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { ChakraFontAwesomeIconProps } from './types/chakra-font-awesome-icon.props';

/**
 * Chakra-wrapped FontAwesomeIcon component.
 *
 * This component combines Chakra UI's styling capabilities with FontAwesome's icon rendering.
 *
 * @component
 * @param {ChakraFontAwesomeIconProps} props - Props for the icon, including Chakra and FontAwesome options.
 * @returns {JSX.Element} The styled FontAwesome icon component.
 */
export const ChakraFontAwesomeIcon = chakra(FontAwesomeIcon) as FC<ChakraFontAwesomeIconProps>;
